// apiAuth.js
import { useContext } from "react";
import { WiMuleSQL } from "./WiMuleSQL";
import firebase from "./firebase";
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { UserContext } from "../contexts/UserContext";

const auth = getAuth(firebase);

export async function login({ email, password }) {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;

    // Extract email and token
    const userEmail = user.email;
    const userToken = await user.getIdToken();

    return { userEmail, userToken };
  } catch (error) {
    throw new Error(error.message);
  }
}

export function getCurrentUser() {
  return auth.currentUser;
}

export async function logout() {
  try {
    await signOut(auth);
    return null;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function createUserAndTriggerForgotPassword(email) {
  try {
    // Generate a random password
    const password = Math.random().toString(36).slice(-8);
    console.log("New User creation request", email, password);
    // Create the user
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    console.log(
      "User created successfully with email:",
      userCredential.user.email
    );

    // Trigger the forgot password function to allow the user to set their password
    await sendPasswordResetEmail(auth, email);
    console.log("Password reset email sent successfully.");

    return { message: "User created and password reset email sent." };
  } catch (error) {
    console.error(
      "Error creating user and sending password reset email:",
      error.message
    );
    throw new Error(error.message);
  }
}

export async function verifyUserAndRetrieve(token) {
  try {
    const response = await fetch(`${WiMuleSQL}/api/Auth/GetUserData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(token),
    });

    if (!response.ok) {
      throw new Error(
        `VerifyUserAndRetrieve - HTTP Error: ${response.status} ${token}`
      );
    }

    return await response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function checkIfUserExists(email) {
  try {
    const response = await fetch(
      `${WiMuleSQL}/api/Auth/CheckIfFirebaseUserExist?email=${email}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `WiMuleToken Validation Failed: ${response.status}, ${errorText}`
      );
    }
    return true; // Since response.ok is true, it implies the response is in the 200-299 range.
  } catch (error) {
    throw new Error(error.message);
  }
}
